// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-e75f3578] .custom-icon-view .gradient {\n  color: #11291B !important;\n}\n@media only screen and (max-width: 768px) {\n.btn-block-xs-only[data-v-e75f3578] {\n    display: block;\n    width: 100%;\n    margin-top: 20px;\n}\n}", ""]);
// Exports
module.exports = exports;
